/**
 * School-user detection by email domain (the part after the @).
 * Intentionally permissive (substring match — ISP domains like comcast.net hit
 * '.net' by design); used only to soft-default the /deals view, never as a
 * security gate. Local parts are excluded so e.g. eduardo@gmail.com won't match.
 */
export const SCHOOL_EMAIL_SUBSTRINGS = [
  'edu',
  '.org',
  '.net',
  'k12',
  'prep',
  'college',
  'uni',
  'university',
  'isd',
  'school',
  'academy',
  'charter',
  'unified',
] as const;

export function isSchoolEmail(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase() ?? '';
  if (!domain) return false;
  return SCHOOL_EMAIL_SUBSTRINGS.some((s) => domain.includes(s));
}
